import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}

  public static readonly prefix = 'UI.scripts.dealer-franchisee.dashboard.widget.IssuedQuotesWidget.';
  public static readonly quoteNetAmount = `${Id.prefix}quoteNetAmount`;
  public static readonly quoteStatus = `${Id.prefix}quoteStatus`;
}

export class LangIssuedQuotesWidget {
  private constructor() {}

  public static quoteNetAmount(params: { label: string }): string {
    return interpolate(Id.quoteNetAmount, params);
  }

  public static quoteStatus(params: { status: string }): string {
    return interpolate(Id.quoteStatus, params);
  }
}

export class IssuedQuotesWidgetModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(
      Id.quoteNetAmount,
      "{{glossary 'quote:plural'}} (Net Amount) - {{label}}",
      'Title for issued quotes widget with date range'
    );
    register.add(Id.quoteStatus, '{{status}}', 'Quote status for chart legend');
  }
}
